<template>
    <path d="M0.902344 10.3711H28.5039" stroke-width="2" />
    <path d="M19.6328 1.5L28.5047 10.3719L19.6328 19.2438" stroke-width="2" stroke-linecap="square" />
</template>
